export default __webpack_public_path__ + "static/media/customKitchen2.d0b99682.jpeg";